import React, { useState } from 'react';
import { Box, ThemeProvider, Tab, Tabs, Divider, Paper, AppBar, Toolbar, IconButton, Typography, Icon } from '@mui/material/';
import Grid from '@mui/material/Grid';

import { createTheme, styled } from '@mui/material/styles';
const darkTheme = createTheme({ palette: { mode: 'dark' } });
const lightTheme = createTheme({ palette: { mode: 'light' } });

export default function Contenedores({ children, titulo, tema, xs, sm, md, lg, }) {
    const [expand, Setexpand] = useState(false);
    function handleExpand() {
        Setexpand((expand) => !expand);
    }
    return (
        <>


            <Grid item xs={xs} sm={sm} md={md} lg={lg} key={titulo}>
                <ThemeProvider theme={tema == 1 ? darkTheme : lightTheme}>
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        p: 2,
                        borderRadius: 2,
                        bgcolor: 'background.default',
                        display: 'grid',

                        gap: 2,
                    }} >



                        <Paper sx={{ padding: 4 }} elevation={8} >
                            <Grid container spacing={2}>
                                <Grid xs={11} >
                                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                        {titulo}
                                    </Typography>

                                </Grid>
                                <Grid xs={1}>
                                    <IconButton onClick={handleExpand}>
                                        {expand && <Icon >keyboard_arrow_down</Icon>}
                                        {!expand && <Icon >keyboard_arrow_up</Icon>}

                                    </IconButton>
                                </Grid>
                            </Grid>



                            <Divider />
                            {!expand && children}
                        </Paper>
                    </Box>
                </ThemeProvider>
            </Grid>


        </>
    );
}